<template>
  <div>
    <h5>{{ $t("currency") }}</h5>
    <div class="center mt-2">
      <div class="row">
        <div
          class="col-lg-3 col-md-4 col-sm-6 col-xs-6 m-1 currency"
          :class="{ currency_selected: c.code === selected_currency.code }"
          v-for="c in hotel.currencies"
          :key="c.code"
          @click="setCurrent(c)"
        >
          <base-icon
            icon_name="check"
            v-if="c.code === selected_currency.code"
          />
          <!-- <base-icon icon_name="minus" v-else /> -->

          <span class="currency_code"> {{ c.code }} </span>
          {{ c.title }}
        </div>
      </div>

      <!-- <ul class="list-group list-group-flush">
        <li
          class="list-group-item"
          :class="{ currency_selected: c.code === selected_currency.code }"
          v-for="c in hotel.currencies"
          :key="c.code"
          @click="setCurrent(c)"
        >
          <base-icon icon_name="check" v-if="c.code === selected_currency.code" />
          <base-icon icon_name="minus" v-else />
          {{ c.code }} {{ c.title }} 
        </li>
      </ul> -->
    </div>

    <br />
    <slot></slot>
  </div>
</template>
<script>
import store from "@/store";
export default {
  name: "ChangeCurrency",
  data: () => ({}),
  mounted() {},
  methods: {
    setCurrent(c) {
      this.$store.dispatch("currency/setCurrency", c);
      this.$store.dispatch("nav/SetToggleCurrency");
    },
  },
  computed: {
    selected_currency() {
      return store.getters["currency/selected_currency"];
    },
    hotel() {
      return store.getters["location_selected/placeSelected"] || {};
    },
  },
};
</script>